export const SIDEBAR_CHATS = 3;

/** The few chats a project shows in the sidebar: what waits for the person
 * first, then the unread ones a bot opened, then the newest; one chat per
 * schedule (its latest run). */
export const sidebarChats = (chats, limit = SIDEBAR_CHATS) => {
  const seen = new Set();
  const latest = (chats || []).filter((c) => {
    if (!c.schedule_id) return true;
    if (seen.has(c.schedule_id)) return false;
    seen.add(c.schedule_id);
    return true;
  });
  const rank = (c) => (c.pending_approvals > 0 ? 0 : c.unread ? 1 : 2);
  return [0, 1, 2].flatMap((r) => latest.filter((c) => rank(c) === r)).slice(0, limit);
};

/** How many chats have something new from a bot the person has not opened yet, over all their
 * bots and BusyBee's main chat (backend /bots/mine unread_chats). */
export const unreadChats = (mine) => [...(mine?.bots || []), ...(mine?.queen ? [mine.queen] : [])]
  .reduce((sum, b) => sum + (b.unread_chats || 0), 0);
